/* AIM Rentals theme JS · v2 */
(function(){
  'use strict';
  const $ = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));
  const money = c => '$' + (c/100).toFixed(2);

  /* Mobile nav */
  const mt = $('[data-mobile-toggle]'), md = $('[data-mobile-drawer]');
  if(mt&&md){ mt.addEventListener('click', ()=>{ md.classList.toggle('open'); md.setAttribute('aria-hidden', md.classList.contains('open')?'false':'true'); }); }

  /* PDP qty + thumbs + tabs + sticky */
  const qm=$('[data-qty-minus]'), qp=$('[data-qty-plus]'), qi=$('input[name="quantity"]');
  if(qm&&qi) qm.addEventListener('click', ()=>{ qi.value=Math.max(1,(parseInt(qi.value,10)||1)-1); });
  if(qp&&qi) qp.addEventListener('click', ()=>{ qi.value=(parseInt(qi.value,10)||1)+1; });
  const main = $('[data-pdp-main]');
  $$('[data-pdp-thumb]').forEach(t=>t.addEventListener('click', ()=>{ if(!main) return; main.src=t.dataset.pdpThumb; $$('.pdp-thumbs img').forEach(x=>x.classList.remove('active')); t.classList.add('active'); }));
  $$('.pdp-tab-nav button').forEach(b=>b.addEventListener('click', ()=>{
    const tabs=b.closest('.pdp-tabs'); if(!tabs) return;
    tabs.querySelectorAll('.pdp-tab-nav button').forEach(x=>x.classList.remove('active'));
    tabs.querySelectorAll('.pdp-tab-body').forEach(x=>x.classList.remove('active'));
    b.classList.add('active');
    const t=tabs.querySelector(`[data-tab-body="${b.dataset.tab}"]`); if(t) t.classList.add('active');
  }));
  const sticky=$('[data-pdp-sticky]'), addBtn=$('.pdp-add'); const stickyBtn=$('[data-sticky-add]'); const form=$('[data-pdp-form]');
  if(sticky&&addBtn){
    const io=new IntersectionObserver(es=>{ es.forEach(e=>sticky.classList.toggle('visible', !e.isIntersecting)); }, {threshold:0});
    io.observe(addBtn);
    if(stickyBtn&&form){ stickyBtn.addEventListener('click', ()=>form.requestSubmit()); }
  }

  /* Urgency clock — "Order in next Xh Ym for same-day ship" until 2pm PT */
  const clock = $('[data-urgency-clock]'), uText = $('[data-urgency-text]');
  if(clock){
    function tick(){
      const now = new Date();
      const pt = new Date(now.toLocaleString('en-US',{timeZone:'America/Vancouver'}));
      const cutoff = new Date(pt); cutoff.setHours(14,0,0,0);
      if(pt >= cutoff){
        uText.innerHTML = 'Order before 2pm PT tomorrow for same-day shipping';
        clock.textContent = '';
        return;
      }
      const ms = cutoff - pt;
      const h = Math.floor(ms/3600000), m = Math.floor((ms%3600000)/60000), s = Math.floor((ms%60000)/1000);
      clock.textContent = `${h}h ${String(m).padStart(2,'0')}m ${String(s).padStart(2,'0')}s`;
    }
    tick(); setInterval(tick,1000);
  }

  /* Fitment confirmer (heuristic — matches title/description text) */
  const fc = $('[data-fitment-confirm]');
  if(fc){
    const r=fc.querySelector('[data-fc-result]');
    fc.querySelector('[data-fc-check]').addEventListener('click', ()=>{
      const mk = fc.querySelector('[data-fc-make]').value.trim();
      const mo = fc.querySelector('[data-fc-model]').value.trim();
      if(!mk||!mo){ r.textContent='Pick a make and enter a model.'; r.className='fc-result warn'; return; }
      const hay = (document.querySelector('.pdp-title')?.textContent + ' ' + (document.querySelector('.pdp-tab-body[data-tab-body="desc"]')?.textContent||'') + ' ' + (document.querySelector('.pdp-tab-body[data-tab-body="fitment"]')?.textContent||'')).toLowerCase();
      const ok = hay.includes(mk.toLowerCase()) && hay.includes(mo.toLowerCase());
      if(ok){ r.textContent = `Confirmed fit for ${mk} ${mo}. Add to cart.`; r.className='fc-result ok'; }
      else { r.innerHTML = `Not 100% sure on ${mk} ${mo}. <a href="mailto:sales@rentwithaim.ca?subject=Fitment check ${encodeURIComponent(document.title)}">Email us your machine details</a> and we'll confirm within 1 business hour.`; r.className='fc-result warn'; }
    });
  }

  /* Finder model index */
  const MODELS = {
    'Caterpillar':['320','323','325','330','336','349','374','390','926M','938M','950','966','972','980','D6','D8','D9','D10','D11'],
    'John Deere':['210','310','410','450','550','650','744','824','844','870','892','953','992'],
    'Komatsu':['PC78','PC138','PC200','PC210','PC290','PC360','PC490','PC650','PC800','WA320','WA380','WA470','WA500','D65','D85','D155','D375'],
    'Cummins':['ISB','ISC','ISL','ISM','ISX','QSB','QSC','QSL','QSM','QSX','X12','X15','B3.3','B4.5','B6.7'],
    'Volvo':['EC140','EC220','EC250','EC300','EC380','EC480','EC750','L60','L70','L90','L110','L150','L180','L220','A30','A35','A40'],
    'Hitachi':['ZX120','ZX135','ZX160','ZX210','ZX250','ZX350','ZX470','ZX670','ZX870'],
    'Case':['CX130','CX160','CX210','CX250','CX350','CX490','621','721','821','921'],
    'Kubota':['KX040','KX057','KX080','U17','U25','U35','U48','U55','SVL75','SVL95','SVL97','SSV65','SSV75'],
    'Bobcat':['S510','S550','S570','S590','S630','S650','S740','S770','S850','T550','T590','T630','T650','T740','T770','T870','E26','E32','E35','E42','E50','E55','E60','E85'],
    'Hyundai':['HX130','HX160','HX220','HX260','HX300','HX380','HX480','HL955','HL960','HL965','HL975'],
    'Kobelco':['SK75','SK85','SK140','SK170','SK210','SK260','SK350','SK500','SK850'],
    'Doosan':['DX140','DX180','DX225','DX235','DX300','DX340','DX380','DX420','DX490','DX530','DL250','DL300','DL420'],
    'JCB':['1CX','2CX','3CX','4CX','JS130','JS145','JS160','JS180','JS220','JS260','JS330','JS460'],
    'New Holland':['E26','E35','E55','E135','E215','E245','E305','L213','L218','L220','L225','L228','L234','C227','C232','C238'],
    'XCMG':['XE15','XE35','XE55','XE60','XE75','XE135','XE150','XE215','XE235','XE305','XE370','XE470','XE500','XE700','XE950']
  };
  $$('[data-parts-finder]').forEach(f=>{
    const mk = f.querySelector('[name="filter.p.m.fitment.make"]');
    const mo = f.querySelector('[name="filter.p.m.fitment.model"]');
    if(!mk||!mo) return;
    mk.addEventListener('change', ()=>{
      const list = MODELS[mk.value] || [];
      mo.innerHTML = '<option value="">'+(list.length?'Select model':'No models listed')+'</option>' + list.map(x=>`<option value="${x}">${x}</option>`).join('');
      mo.disabled = list.length===0;
    });
  });

  /* Search autocomplete: extracted so it can be called on init and re-init */
  function bindPredictiveSearch(){
    const si = $('[data-search-input]'), sr = $('[data-search-results]');
    if(!si||!sr) return;
    /* Avoid double-binding: mark element as bound */
    if(si.dataset.searchBound==='1') return;
    si.dataset.searchBound='1';
    let t;
    si.addEventListener('input', ()=>{
      clearTimeout(t);
      const q = si.value.trim();
      if(q.length<2){ sr.hidden=true; sr.innerHTML=''; return; }
      t = setTimeout(async ()=>{
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const d = await res.json();
          const items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if(!items.length){ sr.innerHTML='<div class="sr-item"><span class="text-muted">No matches. Try a SKU, brand, or fitment.</span></div>'; sr.hidden=false; return; }
          sr.innerHTML = items.map(p=>`<a class="sr-item" href="${p.url}"><img src="${p.image||''}" alt="" loading="lazy"><span><span class="sr-title">${p.title}</span><span class="sr-meta">${p.vendor||''} · ${p.price||''}</span></span></a>`).join('');
          sr.hidden=false;
        } catch(e){ sr.hidden=true; }
      },180);
    });
    document.addEventListener('click', e=>{ if(!si.contains(e.target)&&!sr.contains(e.target)) sr.hidden=true; });
  }
  bindPredictiveSearch();

  /* Cart drawer */
  const drawer = $('[data-cart-drawer]'), bubble = $('[data-cart-bubble]');
  function openCart(){ if(!drawer) return; drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); renderCart(); }
  function closeCart(){ if(!drawer) return; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); }
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click', e=>{ e.preventDefault(); openCart(); }));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click', closeCart));
  async function fetchCart(){ const r = await fetch('/cart.js'); return r.json(); }
  async function changeQty(key, q){ await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})}); renderCart(); }
  async function renderCart(){
    const c = await fetchCart();
    if(bubble) bubble.textContent = c.item_count;
    const items = $('[data-cart-items]'); const total = $('[data-cart-total]');
    const pf = $('[data-progress-fill]'); const pt = $('[data-progress-text]');
    if(total) total.textContent = money(c.total_price);
    if(pf && pt){
      const goal = 25000;
      const pct = Math.min(100, c.total_price/goal*100);
      pf.style.width = pct+'%';
      const remain = Math.max(0, goal - c.total_price);
      pt.textContent = remain === 0 ? '✓ Shipping included on this order' : `Add ${money(remain)} to get shipping included`;
    }
    if(items){
      if(!c.items.length){ items.innerHTML = '<p class="cart-empty">Your cart is empty.</p>'; return; }
      items.innerHTML = c.items.map(it=>`
        <div class="cart-line">
          <img src="${it.image}" alt="" loading="lazy">
          <div class="cart-line-info">
            <strong>${it.product_title}</strong>
            <div class="lp">${it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:''}</div>
            <div class="cart-qty">
              <button type="button" data-cq-minus="${it.key}">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-cq-plus="${it.key}">+</button>
            </div>
          </div>
          <div class="cart-line-amt">${money(it.final_line_price)}</div>
        </div>`).join('');
      items.querySelectorAll('[data-cq-minus]').forEach(b=>b.addEventListener('click', ()=>changeQty(b.dataset.cqMinus, (c.items.find(x=>x.key===b.dataset.cqMinus)?.quantity||1)-1)));
      items.querySelectorAll('[data-cq-plus]').forEach(b=>b.addEventListener('click', ()=>changeQty(b.dataset.cqPlus, (c.items.find(x=>x.key===b.dataset.cqPlus)?.quantity||1)+1)));
    }
  }
  async function refreshBubble(){ try { const c = await fetchCart(); if(bubble) bubble.textContent = c.item_count; } catch(e){} }
  $$('[data-pdp-form]').forEach(f=>f.addEventListener('submit', async e=>{
    e.preventDefault();
    const fd = new FormData(f);
    const btn = f.querySelector('.pdp-add');
    const orig = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled = true; btn.innerHTML = 'Adding…'; }
    try {
      await fetch('/cart/add.js',{method:'POST',body:fd});
      await refreshBubble();
      openCart();
    } catch(err){ console.error(err); }
    finally { if(btn){ btn.disabled = false; btn.innerHTML = orig; } }
  }));
  if(bubble){ fetchCart().then(c=>{ bubble.textContent = c.item_count; }); }

  /* Exit-intent — desktop mouseleave, mobile after 30s scroll-up */
  const ei = $('[data-exit-intent]');
  if(ei){
    const KEY = 'aim_ei_shown';
    function show(){ if(sessionStorage.getItem(KEY)) return; ei.classList.add('open'); ei.setAttribute('aria-hidden','false'); sessionStorage.setItem(KEY,'1'); }
    if(window.matchMedia('(min-width:900px)').matches){
      document.addEventListener('mouseleave', e=>{ if(e.clientY<=0) show(); });
    } else {
      let last=window.scrollY, t0=Date.now();
      window.addEventListener('scroll', ()=>{
        const now=Date.now();
        if(now-t0>15000 && window.scrollY<last-50) show();
        last=window.scrollY;
      }, {passive:true});
    }
    ei.querySelectorAll('[data-ei-close]').forEach(b=>b.addEventListener('click', ()=>{ ei.classList.remove('open'); ei.setAttribute('aria-hidden','true'); }));
  }

  /* Reveal-on-scroll */
  const ro = new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); ro.unobserve(e.target); } }), {threshold:.15});
  $$('[data-reveal]').forEach(el=>ro.observe(el));
})();

/* Collection facets mobile drawer */
(function(){
  const panel = document.querySelector('[data-facets-panel]');
  if(!panel) return;
  document.querySelectorAll('[data-facets-open]').forEach(b=>b.addEventListener('click', ()=>{
    panel.classList.add('open');
    b.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
  }));
  document.querySelectorAll('[data-facets-close]').forEach(b=>b.addEventListener('click', ()=>{
    panel.classList.remove('open');
    document.querySelectorAll('[data-facets-open]').forEach(o=>o.setAttribute('aria-expanded','false'));
    document.body.style.overflow='';
  }));
})();

/* Predictive search re-init: fires on /search page load and back/forward cache restore.
   The main IIFE already calls bindPredictiveSearch() on first parse. These handlers
   cover two additional cases:
   1. DOMContentLoaded  - in case the script is deferred and the IIFE ran too early
      (e.g. Shopify loads theme.js with defer in some storefronts)
   2. pageshow          - handles bfcache (browser back/forward); the page is restored
      from cache without re-running scripts, so connectedCallback on custom elements
      may not fire again. We clear the searchBound flag so the listener re-attaches
      cleanly to any replaced DOM node.
*/
(function(){
  function reinitSearch(){
    const si = document.querySelector('[data-search-input]');
    if(si) delete si.dataset.searchBound;
    /* bindPredictiveSearch is defined inside the main IIFE closure; expose a
       lightweight re-init here that mirrors it without a closure dependency. */
    const sr = document.querySelector('[data-search-results]');
    if(!si||!sr) return;
    if(si.dataset.searchBound==='1') return;
    si.dataset.searchBound='1';
    let timer;
    si.addEventListener('input', ()=>{
      clearTimeout(timer);
      const q = si.value.trim();
      if(q.length<2){ sr.hidden=true; sr.innerHTML=''; return; }
      timer = setTimeout(async ()=>{
        try{
          const res = await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6');
          const d = await res.json();
          const items = (d.resources&&d.resources.results&&d.resources.results.products)||[];
          if(!items.length){ sr.innerHTML='<div class="sr-item"><span class="text-muted">No matches. Try a SKU, brand, or fitment.</span></div>'; sr.hidden=false; return; }
          sr.innerHTML=items.map(p=>`<a class="sr-item" href="${p.url}"><img src="${p.image||''}" alt="" loading="lazy"><span><span class="sr-title">${p.title}</span><span class="sr-meta">${p.vendor||''} &middot; ${p.price||''}</span></span></a>`).join('');
          sr.hidden=false;
        }catch(e){ sr.hidden=true; }
      },180);
    });
    document.addEventListener('click', e=>{ if(!si.contains(e.target)&&!sr.contains(e.target)) sr.hidden=true; });
  }

  /* DOMContentLoaded: safe re-run on deferred load */
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', reinitSearch);
  } else {
    reinitSearch();
  }

  /* pageshow: covers bfcache restore (persisted=true means page came from cache) */
  window.addEventListener('pageshow', e=>{
    if(e.persisted){
      /* Clear bound flag so listener re-attaches to the live DOM node */
      const si = document.querySelector('[data-search-input]');
      if(si) delete si.dataset.searchBound;
      reinitSearch();
    }
  });
})();
/* =============================================================
   AIM Rentals · _collection_extra.js
   Collection page enhancements — v2
   MERGE: Append ALL contents of this file into assets/theme.js
   (append after the existing "Collection facets mobile drawer"
   IIFE at the bottom of theme.js)

   Covers:
   1. Filter checkbox → navigate (url_to_add / url_to_remove)
   2. Dual-handle price range slider
   3. Active-pill bar refresh (no reload needed — pills are
      server-rendered but JS keeps price labels live)
   ============================================================= */

/* ── 1. Filter checkbox navigation ─────────────────────────── */
(function () {
  'use strict';

  /* Each checkbox carries data-filter-url (add) and
     data-filter-remove (remove). On change we navigate. */
  document.querySelectorAll('.col-filter-check').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var url = cb.checked
        ? cb.dataset.filterUrl
        : cb.dataset.filterRemove;
      if (url) window.location.href = url;
    });
  });
})();

/* ── 2. Dual-handle price range slider ─────────────────────── */
(function () {
  'use strict';

  var track    = document.querySelector('[data-price-track]');
  var fill     = document.querySelector('[data-price-fill]');
  var minInput = document.querySelector('[data-price-min]');
  var maxInput = document.querySelector('[data-price-max]');
  var fromLbl  = document.querySelector('.col-price-from');
  var toLbl    = document.querySelector('.col-price-to');
  var applyBtn = document.querySelector('[data-price-apply]');
  var resetBtn = document.querySelector('[data-price-reset]');

  if (!track || !minInput || !maxInput) return;

  var rangeMin = parseFloat(minInput.min) || 0;
  var rangeMax = parseFloat(maxInput.max) || 100000;

  function formatMoney(val) {
    /* Simple CAD formatting — always show whole dollars */
    return '$' + Math.round(val).toLocaleString('en-CA');
  }

  function updateFill() {
    var lo = parseFloat(minInput.value);
    var hi = parseFloat(maxInput.value);
    var span = rangeMax - rangeMin;
    if (span <= 0) return;
    var leftPct  = ((lo - rangeMin) / span) * 100;
    var rightPct = ((hi - rangeMin) / span) * 100;
    fill.style.left  = leftPct + '%';
    fill.style.width = (rightPct - leftPct) + '%';
    if (fromLbl) fromLbl.textContent = formatMoney(lo);
    if (toLbl)   toLbl.textContent   = formatMoney(hi);
  }

  function showReset() {
    if (resetBtn) resetBtn.style.display = '';
  }

  minInput.addEventListener('input', function () {
    var lo = parseFloat(minInput.value);
    var hi = parseFloat(maxInput.value);
    if (lo >= hi) minInput.value = hi - 1;
    updateFill();
    showReset();
  });

  maxInput.addEventListener('input', function () {
    var lo = parseFloat(minInput.value);
    var hi = parseFloat(maxInput.value);
    if (hi <= lo) maxInput.value = lo + 1;
    updateFill();
    showReset();
  });

  /* Apply: build URL by injecting gte/lte params */
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var lo  = Math.round(parseFloat(minInput.value));
      var hi  = Math.round(parseFloat(maxInput.value));
      var url = new URL(window.location.href);
      /* Remove any existing price filter params first */
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.set('filter.v.price.gte', lo);
      url.searchParams.set('filter.v.price.lte', hi);
      url.searchParams.delete('page'); /* Reset to page 1 */
      window.location.href = url.toString();
    });
  }

  /* Initialise fill on load */
  updateFill();

  /* Show reset if price filter is active on load */
  var lo0 = parseFloat(minInput.value);
  var hi0 = parseFloat(maxInput.value);
  if (lo0 > rangeMin || hi0 < rangeMax) {
    showReset();
  }
})();

/* ── 3. Sort select — preserve active filter params ────────── */
(function () {
  'use strict';

  /*
    The existing sort select uses onchange="window.location.href=this.value"
    which drops active filter params. This block upgrades the col-sort-select
    to append sort_by while keeping all current URL params.
  */
  var sel = document.getElementById('col-sort-select');
  if (!sel) return;

  /* Remove the inline onchange */
  sel.removeAttribute('onchange');

  sel.addEventListener('change', function () {
    var sortBy = sel.value.replace('?sort_by=', '');
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortBy);
    url.searchParams.delete('page'); /* Reset to page 1 on sort change */
    window.location.href = url.toString();
  });

  /* Reflect current sort_by in select */
  var current = new URL(window.location.href).searchParams.get('sort_by');
  if (current) {
    Array.from(sel.options).forEach(function (opt) {
      var optVal = opt.value.replace('?sort_by=', '');
      if (optVal === current) opt.selected = true;
    });
  }
})();
/* =============================================================
   AIM Rentals — PDP Pro extra JS  · _pdp_extra.js · v2.1
   Append to theme.js (Worker H will batch)
   Covers:
     - Pill tab nav (ARIA-compliant, animated)
     - Fitment confirmer with Year field + mailto composition
     - Sticky ATC IntersectionObserver fix (mobile force-display)
     - Related products band empty-state hide (CSS :has fallback)
   ============================================================= */

(function () {
  'use strict';

  /* ── Utility ────────────────────────────────────────────── */
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ── Pill tab nav (replaces flat button tabs) ────────────── */
  /*
   * Supports keyboard nav per ARIA tab pattern:
   *   ArrowLeft / ArrowRight → move focus
   *   Home / End             → first/last tab
   *   Enter / Space          → activate focused tab
   */
  $$('[data-tabs]').forEach(function (container) {
    var navBtns = $$('.pdp-tab-pill', container);
    var bodies  = $$('.pdp-tab-body', container);

    function activateTab(btn) {
      navBtns.forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('tabindex', '-1');
      });
      bodies.forEach(function (bd) { bd.classList.remove('active'); });

      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      btn.setAttribute('tabindex', '0');

      var target = container.querySelector('[data-tab-body="' + btn.dataset.tab + '"]');
      if (target) target.classList.add('active');
    }

    navBtns.forEach(function (btn, idx) {
      btn.addEventListener('click', function () { activateTab(btn); });
      btn.addEventListener('keydown', function (e) {
        var newIdx = idx;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          newIdx = (idx + 1) % navBtns.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          newIdx = (idx - 1 + navBtns.length) % navBtns.length;
        } else if (e.key === 'Home') {
          e.preventDefault(); newIdx = 0;
        } else if (e.key === 'End') {
          e.preventDefault(); newIdx = navBtns.length - 1;
        }
        if (newIdx !== idx) {
          navBtns[newIdx].focus();
          activateTab(navBtns[newIdx]);
        }
      });
    });
  });

  /* ── Fitment confirmer — year + make + model ─────────────── */
  /*
   * Audit fix #6: year select is optional context.
   * Check logic: still validates Make + Model presence.
   * Year is passed to the mailto if filled.
   */
  $$('[data-fitment-confirm]').forEach(function (fc) {
    var yearSel   = $('[data-fc-year]', fc);
    var makeSel   = $('[data-fc-make]', fc);
    var modelInp  = $('[data-fc-model]', fc);
    var checkBtn  = $('[data-fc-check]', fc);
    var resultEl  = $('[data-fc-result]', fc);

    if (!checkBtn || !makeSel || !modelInp || !resultEl) return;

    checkBtn.addEventListener('click', function () {
      var yr = yearSel ? yearSel.value.trim() : '';
      var mk = makeSel.value.trim();
      var mo = modelInp.value.trim();

      /* Require make + model */
      if (!mk || !mo) {
        resultEl.textContent = 'Pick a make and enter a model to check fit.';
        resultEl.className = 'fc-result warn';
        return;
      }

      /* Heuristic: search title + description + fitment tab text */
      var hay = [
        (document.querySelector('.pdp-title')  || {}).textContent || '',
        (document.querySelector('[data-tab-body="desc"]')    || {}).textContent || '',
        (document.querySelector('[data-tab-body="fitment"]') || {}).textContent || ''
      ].join(' ').toLowerCase();

      var mkMatch = hay.includes(mk.toLowerCase());
      var moMatch = hay.includes(mo.toLowerCase());

      var label = (yr ? yr + ' ' : '') + mk + ' ' + mo;

      if (mkMatch && moMatch) {
        resultEl.textContent = 'Confirmed fit for ' + label + '. Add to cart.';
        resultEl.className = 'fc-result ok';
      } else {
        /* Build mailto with year context if supplied */
        var subject = encodeURIComponent('Fitment check: ' + (yr ? yr + ' ' : '') + mk + ' ' + mo + ' — ' + document.title);
        var body    = encodeURIComponent(
          'Hi AIM team,\n\nI need to confirm fitment for the following machine:\n' +
          (yr ? 'Year: ' + yr + '\n' : '') +
          'Make: ' + mk + '\n' +
          'Model: ' + mo + '\n\n' +
          'Product page: ' + window.location.href + '\n\n' +
          'Please let me know if this part fits. Thanks.'
        );
        resultEl.innerHTML =
          'Not 100% sure on ' + label + '. ' +
          '<a href="mailto:sales@rentwithaim.ca?subject=' + subject + '&body=' + body + '">' +
          'Email us your machine details</a> — we\'ll confirm within 1 business hour.';
        resultEl.className = 'fc-result warn';
      }
    });

    /* Allow Enter in model input to trigger check */
    modelInp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); checkBtn.click(); }
    });
  });

  /* ── Sticky ATC — IntersectionObserver with mobile fix ───── */
  /*
   * Audit finding: sticky bar doesn't paint on mobile.
   * Root cause: transform:translateY(100%) on .pdp-sticky is removed
   * by toggling .visible, but some mobile browsers paint the element
   * as display:none-equivalent when off-screen. We force display:flex
   * on the row BEFORE the observer fires so the bar is layout-ready.
   *
   * Fix: use rootMargin to fire a few px BEFORE the button scrolls
   * out, and ensure .pdp-sticky is never removed from paint layer.
   */
  var sticky   = document.querySelector('[data-pdp-sticky]');
  var addBtn   = document.querySelector('.pdp-add');
  var stickyRow = sticky ? sticky.querySelector('.pdp-sticky-row') : null;

  if (sticky && addBtn) {
    /* Pre-paint: ensure sticky bar is on the GPU layer always */
    sticky.style.willChange = 'transform';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting;
          sticky.classList.toggle('visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -56px 0px' /* trigger slightly before ATC fully hides on mobile */
      }
    );

    observer.observe(addBtn);

    /* Wire sticky button → submit main form */
    var form = document.querySelector('[data-pdp-form]');
    var stickyAddBtn = document.querySelector('[data-sticky-add]');
    if (stickyAddBtn && form) {
      stickyAddBtn.addEventListener('click', function () {
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          /* Safari <16 fallback */
          var hidden = document.createElement('input');
          hidden.type = 'submit';
          hidden.style.display = 'none';
          form.appendChild(hidden);
          hidden.click();
          form.removeChild(hidden);
        }
      });
    }
  }

  /* ── Related band: CSS :has() fallback for older browsers ─── */
  /*
   * _pdp.css uses `.pdp-related:not(:has(.card)) { display:none }`
   * For browsers without :has() support (< Safari 15.4, < Chrome 105)
   * we hide the band in JS if it has no .card children.
   */
  var relatedBand = document.querySelector('[data-pdp-related]');
  if (relatedBand) {
    var hasCards = relatedBand.querySelector('.card');
    if (!hasCards) {
      relatedBand.style.display = 'none';
    }
  }

})();
